module.exports = __webpack_public_path__ + "static/media/Sake_Specifications_gradient.288016ab.png";